import React, { useRef} from 'react';
import {Dialog} from "primereact/dialog";


import {TablaDetalleCompensacion} from "../../../Tables/TablaDetalleCompensacion";
import { useReactToPrint } from "react-to-print";
import {UseLoader} from "../../../../hooks/useLoader";

export const ModalDeatailEvent = ({show, hide, fields}) => {
    const componentRef = useRef(null);
    const [handleLoad] = UseLoader();

    const handlePrint = useReactToPrint({
        documentTitle: "Detalle Compensacion",
        content: () => componentRef.current,
        onBeforePrint:() => handleLoad(true),
        onAfterPrint: () => handleLoad(false),
    });

    const renderFooter = () => {
         return (
             <div className="flex align-items-center justify-end">
                 <button
                     className="danger-color-btn btn"
                     type="button"
                     onClick={hide}
                 >
                     cerrar
                 </button>
                 <button
                     className="secundary-color-btn btn"
                     type="button"
                     onClick={handlePrint}
                 >
                     Imprimir
                 </button>
             </div>

         );
     }

    return (
        <>
            <Dialog modal maximizable header="Detalle compensación" visible={show} style={{width: '90vw'}}
                    onHide={hide} footer={renderFooter}>
                <div className="container-relative ">
                    <TablaDetalleCompensacion ref={componentRef} fields={fields}/>
                </div>

            </Dialog>
        </>
    );
};


